/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
/* tslint:disable: no-duplicate-imports */
import { Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { IFlyoutCartLineItemViewProps } from './components/flyout-cart-line-items';
import { ICartIconViewProps } from './smwe-minicart';

const ariaHiddenFunc=()=>{
    if(typeof window!=='undefined'){
        const ariaHidden=document.getElementsByClassName('msc-flyout-inner');
        for(var i=0;i<ariaHidden.length;i++){
            ariaHidden[i].setAttribute('aria-hidden','false');
        }
    }
    return;
};

const _renderCartlines = (cartLines: IFlyoutCartLineItemViewProps[] | undefined, props: ICartIconViewProps): JSX.Element[] | null => {
    if (cartLines) {
        return cartLines.map((cartLine, index) => {
            return (
                <Node {...props.miniCartItemWrapper} key={index}>
                    {cartLine.cartline}
                    {cartLine.storeLocation}
                    {cartLine.remove}
                </Node>
            );
        });
    }

    return null;
};

const CartIconView: React.FC<ICartIconViewProps> = (props: ICartIconViewProps) => (
    <div onFocus={ariaHiddenFunc}>
        <Node {...props.miniCartWrapper} {...props.renderModuleAttributes(props)}>
            {props.cartIcon}
            {props.FlyoutContainer ? (
                <Node {...props.FlyoutContainer}>
                    {props.flyoutTitle}
                    <Node {...props.CartlinesWrapper}>
                        {_renderCartlines(props.cartlines, props)}
                    </Node>
                    {props.totalPrice}
                    {props.checkoutAsSignInUserButton}
                    {props.goToCartButton}
                </Node>
            ) : false }
        </Node>
    </div>
);

export default CartIconView;